import React from 'react';

export interface HorizontalRatioProps
  extends Readonly<{
    widthRatio: number;
    heightRatio: number;
    style?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    children?: React.ReactNode;
  }> {}

export const HorizontalRatio = React.memo<HorizontalRatioProps>((props) => {
  const { widthRatio, heightRatio, style, contentStyle, children } = props;

  const RootStyles = React.useMemo(() => {
    const height = (heightRatio / widthRatio) * 100;

    const rootStyles: React.CSSProperties = {
      paddingBottom: `${height}%`,
      position: 'relative',
      width: '100%',
      ...style,
    };

    return rootStyles;
  }, [heightRatio, widthRatio, style]);

  const ContentStyles = React.useMemo(() => {
    const contentStyles: React.CSSProperties = {
      height: '100%',
      overflow: 'hidden',
      position: 'absolute',
      width: '100%',
      ...contentStyle,
    };

    return contentStyles;
  }, [contentStyle]);

  return (
    <div style={RootStyles}>
      <div style={ContentStyles}>{children}</div>
    </div>
  );
});
